import { render, staticRenderFns } from "./SingleProductsNew.vue?vue&type=template&id=41ee8774&"
import script from "./SingleProductsNew.vue?vue&type=script&lang=js&"
export * from "./SingleProductsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports